import React, { useState, useEffect } from "react";
import "../css/CookieBanner.css";

function CookieBanner() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("cookiesAccepted");
    if (!accepted) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookiesAccepted", "true");
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-banner">
      <p>
        Usamos únicamente cookies estrictamente necesarias para que la web funcione correctamente.
      </p>
      <button onClick={handleAccept}>Aceptar</button>
    </div>
  );
}

export default CookieBanner;